<template>
  <main-layout>
    <v-container fluid>
      <div style="text-align: right">
        <v-btn outline color="primary" @click="createCampaign"
          ><v-icon>add</v-icon>&nbsp;เพิ่มแคมเปญ</v-btn
        >
      </div>
      <div class="primary--text mt-2">
        <h1 class="mb-4">ตั้งค่าแคมเปญ</h1>
        <div v-if="loading" class="mt-5">
          <scale-loader class="my-4" :loading="true" color="gray"></scale-loader>
        </div>
        <div v-else>
          <template v-if="campaigns && campaigns.length > 0">
            <div v-for="(campaign, index) in campaigns" :key="campaign.id" class="mb-3">
              <v-layout wrap>
                <v-flex xs9 sm9>
                  <div style="display: flex; flex: wrap">
                    <div style="width: 60px">
                      <toggle-button
                        :value="campaign.is_enabled"
                        :sync="true"
                        :loading="true"
                        :color="$vuetify.theme.success"
                        @change="setCampaignStatus($event, campaign.id, index, campaign.type)"
                      />
                    </div>
                    <div>
                      <b style="font-size: 18px">{{ campaign.name }}</b>
                      <p>
                        ระยะเวลา {{ campaign.start_timestamp | DateFormat('DD/MM/YYYY HH:mm') }} -
                        {{
                          dayjs(campaign.end_timestamp).subtract(1, 'minute').toISOString()
                            | DateFormat('DD/MM/YYYY HH:mm')
                        }}
                      </p>
                      <p>คำอธิบายแคมเปญ : {{ campaign.description }}</p>
                    </div>
                  </div>
                </v-flex>
                <v-flex xs3 sm3 style="text-align: end">
                  <v-btn icon color="primary" @click="editCampaign(campaign)">
                    <v-icon>edit</v-icon>
                  </v-btn>
                  <v-btn icon color="primary" @click="deleteCampaign(campaign.id)">
                    <v-icon>delete</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
              <v-divider></v-divider>
            </div>
          </template>
          <div v-else class="mt-5" style="text-align: center; color: gray">ไม่มีข้อมูล</div>
          <hr v-if="campaigns.length == 0" />
          <div class="mt-4">
            <div class="primary--text primary--text">ตั้งค่าพื้นหลังหน้าลงทะเบียน</div>
            <div v-if="loadingRegisterBackground" class="mt-5">
              <scale-loader class="my-4" :loading="true" color="gray"></scale-loader>
            </div>
            <div
              v-else
              class="pb-3 form-control"
              :class="{ 'has-error': errors.has('registerBackground') }"
            >
              <UploadFile
                id="registerBackground"
                v-model="registerBackground"
                v-validate="'required'"
                :max="1"
                data-vv-name="registerBackground"
                data-vv-as="พื้นหลังหน้าลงทะเบียน"
              >
                <template #boxForUpload>
                  <div>
                    <v-icon color="primary" style="cursor: pointer">backup</v-icon
                    >&nbsp;เลือกไฟล์เพื่ออัปโหลด
                  </div>
                </template>
              </UploadFile>
              <span v-show="errors.has('registerBackground')" class="text-error">{{
                errors.first('registerBackground')
              }}</span>
              <div class="mt-2">
                ขนาด 385 * 835 px (เว้นด้านบน 320 px, เว้น Input Box 490 px, ด้านล่าง 130 px)
              </div>
            </div>
            <v-btn color="primary" @click="onSaveRegisterBackground">บันทึก</v-btn>
            <v-btn
              v-if="!IsEditRegistrationBackground"
              color="primary"
              @click="onEditRegistrationBackground"
              >แก้ไข</v-btn
            >
            <v-btn
              v-if="IsEditRegistrationBackground"
              color="primary"
              @click="onEditRegistrationBackground"
              >ยกเลิก</v-btn
            >
          </div>
        </div>
      </div>
      <v-dialog v-model="campaignDialog" width="800px" persistent>
        <v-card>
          <CampaignDetail
            :campaign-type-ops="campaignTypeOps"
            :detail="campaignDetail"
            @close="onCloseCampaignDetail"
          ></CampaignDetail>
        </v-card>
      </v-dialog>
    </v-container>
  </main-layout>
</template>

<script>
import dayjs from 'dayjs'
import api from '@/api'
import { mapGetters } from 'vuex'
import { ToggleButton } from 'vue-js-toggle-button'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import UploadFile from './UploadMultipleFile.vue'
import CampaignDetail from './CampaignDetail.vue'
import { PAGE } from '@/constants/page.js'
import toaMegapaintApi from '@/api/toa-mega-paint.js'

export default {
  components: {
    ScaleLoader,
    ToggleButton,
    CampaignDetail,
    UploadFile
  },
  data() {
    return {
      loading: false,
      campaigns: [],
      campaignTypeOps: '',
      campaignDialog: false,
      campaignDetail: null,
      registerBackground: [],
      previousRegisterBackground: [],
      loadingRegisterBackground: false,
      IsEditRegistrationBackground: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    this.getCampaigns()
    this.getRegisterBackground()
  },
  methods: {
    dayjs,
    async getEnabledCampagin() {
      let payload = {
        pageid: this.selectedBot.pageid,
        source: 'cms'
      }
      if (PAGE.TOA_MEGA_PAINT.includes(this.selectedBot.pageid)) {
        try {
          let result = await toaMegapaintApi.getCampaign(payload)
          result = result.data
          let data = result.data.filter((el) => {
            return !el.is_deleted
          })
          this.$store.commit('SET_TOA_ENABLE_CAMPAGIN', data)
          if (this.campaignList && this.campaignList.length > 0) {
            this.$store.commit('SET_TOA_CAMPAIGN', this.campaignList[0])
          }
        } catch (error) {
          console.error(error)
        }
      } else {
        return new Promise((resolve, reject) => {
          api.TOAECOUPONgetAllCampaign(payload, async (err, result) => {
            if (result.responsecode == 200) {
              let data = result.data.filter((el) => {
                return !el.is_deleted
              })
              this.$store.commit('SET_TOA_ENABLE_CAMPAGIN', data)
              if (this.campaignList && this.campaignList.length > 0) {
                this.$store.commit('SET_TOA_CAMPAIGN', this.campaignList[0])
              }
              resolve()
            }
            reject()
          })
        })
      }
    },
    async getCampaigns() {
      this.loading = true
      let data = {
        pageid: this.selectedBot.pageid
      }
      if (PAGE.TOA_MEGA_PAINT.includes(this.selectedBot.pageid)) {
        try {
          const result = await toaMegapaintApi.getCampaign(data)
          this.campaigns = result.data.data
        } catch (error) {
          console.error(error)
        } finally {
          this.loading = false
        }
      } else {
        api.getTOAECOUPONCampaigns(data, (err, result) => {
          this.loading = false
          if (result.responsecode == 200) {
            this.campaigns = result.data
          }
        })
      }
    },
    async setCampaignStatus(event, campaignId, index, type) {
      // if (event.value) {
      //   let IsDuplicate = this.checkCampaignStatusByType(type)
      //   if (IsDuplicate) {
      //     this.$swal.fire(
      //       'ไม่สามารถดำเนินการได้',
      //       'เนื่องจากมีแคมเปญเปิดอยู่ในประเภทแคมเปญนี้แล้ว',
      //       'error'
      //     )
      //     return
      //   }
      // }

      this.$store.dispatch('loading')
      let data = {
        pageid: this.selectedBot.pageid,
        page_id: this.selectedBot.pageid,
        isEnabled: event.value,
        is_enabled: event.value,
        campaignId: campaignId
      }
      if (PAGE.TOA_MEGA_PAINT.includes(this.selectedBot.pageid)) {
        try {
          await toaMegapaintApi.postCampaignStatus(data)
          this.campaigns[index].is_enabled = !this.campaigns[index].is_enabled
        } catch (error) {
          console.error(error)
        } finally {
          this.$store.dispatch('loading')
        }
      } else {
        api.TOAECOUPONSetCampaignStatus(data, (err, result) => {
          this.$store.dispatch('loading')
          this.campaigns[index].is_enabled = !this.campaigns[index].is_enabled
        })
      }
    },
    deleteCampaign(campaignId) {
      // Dialog for confirm
      this.$swal
        .fire({
          icon: 'error',
          text: 'คุณต้องการลบแคปเปญใช่หรือไม่',
          showCancelButton: true,
          cancelButtonText: 'ยกเลิก',
          confirmButtonText: 'ตกลง'
        })
        .then(async (result) => {
          if (result.value) {
            this.$store.dispatch('loading')
            let data = {
              pageid: this.selectedBot.pageid,
              page_id: this.selectedBot.pageid,
              campaignId: campaignId
            }
            if (PAGE.TOA_MEGA_PAINT.includes(this.selectedBot.pageid)) {
              try {
                await toaMegapaintApi.deleteCamapign(campaignId, data)
                this.getCampaigns()
                this.getEnabledCampagin()
              } catch (error) {
                console.error(error)
              } finally {
                this.$store.dispatch('loading')
              }
            } else {
              api.TOAECOUPONDeleteCampaign(data, (err, result) => {
                this.$store.dispatch('loading')
                this.getCampaigns()
                this.getEnabledCampagin()
              })
            }
          }
        })
    },
    checkCampaignStatusByType(type) {
      let IsDuplicate = false
      let result = this.campaigns.filter((f) => f.type == type && f.is_enabled)
      if (result && result.length > 0) {
        IsDuplicate = true
      }
      return IsDuplicate
    },
    createCampaign() {
      this.campaignTypeOps = 'create'
      this.campaignDetail = null
      this.campaignDialog = true
    },
    editCampaign(campaign) {
      this.campaignTypeOps = 'edit'
      this.campaignDetail = campaign
      this.campaignDialog = true
    },
    onCloseCampaignDetail(IsGetData) {
      this.campaignDialog = false
      this.campaignTypeOps = ''
      this.campaignDetail = null
      if (IsGetData) {
        this.getCampaigns()
        this.getEnabledCampagin()
      }
    },
    async onSaveRegisterBackground() {
      if (await this.$validator.validateAll()) {
        this.$store.dispatch('loading')
        let payload = {
          pageid: this.selectedBot.pageid,
          image: this.registerBackground[0]
        }
        api.TOAECOUPONSetRegisterBackground(payload, (err, result) => {
          this.$store.dispatch('loading')
        })
      }
    },
    getRegisterBackground() {
      this.loadingRegisterBackground = true
      let payload = {
        pageid: this.selectedBot.pageid,
        source: 'cms'
      }
      api.TOAECOUPONGetRegisterBackground(payload, (err, result) => {
        this.loadingRegisterBackground = false
        if (result.responsecode == 200 && result.data && result.data.image) {
          this.registerBackground = [result.data.image]
        }
      })
    },
    onEditRegistrationBackground() {
      this.IsEditRegistrationBackground = true
      this.previousRegisterBackground = registerBackground[0]
      this.registerBackground = []
    },
    onCancelRegistrationBackground() {
      this.IsEditRegistrationBackground = false
      this.registerBackground = [this.previousRegisterBackground]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/toaecoupon/Campaign.vue